export const getInitialReflectionSaveState = (
  projectProcessId: number,
  reflection?: ReflectionEntity
) => ({
  id: reflection?.id || undefined,
  result: reflection?.result || 0,
  contributed:
    reflection?.contributed === undefined ? true : !!reflection.contributed,
  finished: reflection?.finished || false,
  project_process_id: projectProcessId,
  reflection_on_student: reflection?.for_user?.id || undefined,
  note: reflection?.note || [],
  emotions:
    reflection?.emotions.map((e) => ({
      id: e.id,
      description: e.pivot.description,
    })) || [],
  sparks: reflection?.sparks.map((e) => e.id) || [],
  dreams: reflection?.dreams?.map((e) => e.id) || [],
});
